import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './store/store';
import { NotificationProvider } from "./services/NotificationContext"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
    <Router>
        <Provider store={store}>
            <React.StrictMode>
                <ChakraProvider>
                    <NotificationProvider>
                        <GoogleOAuthProvider clientId="1062042962594-5mjoegj20ll0vf1idb4otn8o6b5p0qd0.apps.googleusercontent.com">
                            <App />
                        </GoogleOAuthProvider>
                    </NotificationProvider>
                </ChakraProvider>
            </React.StrictMode>
        </Provider>
    </Router>
);

reportWebVitals();
